import cliente_model from '@/shared/models/cliente_model';
import estado_solicitud_model from '@/shared/models/estado_solicitud_model';
import usabilidad_model from '@/shared/models/usabilidad_model';
import unidad_medida_model from '@/shared/models/unidad_medida_model';
import request_elemento_model from './request_elemento_model';
import request_producto_model from './request_producto_model';

export default {
  Codigo: null,
  CodigoCotizacion: null,
  CodigoEstado: null,
  FechaEstado: null,
  CodigoCliente: null,
  Observaciones: null,
  Notas: null,
  CodigoUnidadVenta: null,
  Referencia: null,
  CodigoUsabilidad: null,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  EstadoSolicitud: { ...estado_solicitud_model, Codigo: 1 },
  CodigoETVersion: null,
  CodigoETBase: null,
  VersionET: null,
  Cliente: { ...cliente_model },
  SolicitudAdjunto: [],
  SolicitudProducto: [{ ...request_producto_model, ItemProducto: 1 }],
  SolicitudElemento: [{ ...request_elemento_model, ItemElemento: 1 }],
  SolicitudEntregas: [],
  SolicitudCantidad: [],
  Usabilidad: { ...usabilidad_model },
  UnidadVenta: { ...unidad_medida_model },
};
